module.exports = __webpack_public_path__ + "img/yqxc.383b9970.jpg";